import { Toast } from "antd-mobile";

import codeMsg from "~/common/dict/err.code.msg";

function throwError() {}
const server = {
  success: throwError,
  fail: throwError,
  info: throwError,
  loading: throwError,
  offline: throwError,
};

const toast = {
  ...Toast,
  info: (content, duration, onClose, mask, force) => {
    // eslint-disable-next-line
    if (window.__NEXT_DATA__.requireLogin && codeMsg["FE.1"] === content && !force) {
      return;
    }
    Toast.info(content, duration, onClose, mask);
  },
};

export default process.browser ? toast : server;
